import React from "react";
import { ContentLayout, HeaderBreadcrumbs } from "../../../shared";
import { useFullTaxInvoice } from "../hooks";
import { FullTaxInvoiceList } from "./FullTaxInvoiceList";
import { FullTaxInvoiceSettings } from "./FullTaxInvoiceSettings";

export const FullTaxInvoicePage = () => {
  // One hook for both tabs, so the settings are fetched once and shared with the listing
  const fullTaxInvoice = useFullTaxInvoice();

  const breadcrumbs = [
    { name: "Dashboard", href: fullTaxInvoice.isStoreAdmin ? "/store-admin" : "/" },
    { name: "Full Tax Invoices" },
  ];

  const tabs = [
    {
      label: "FTI Listing",
      value: "1",
      panel: <FullTaxInvoiceList {...fullTaxInvoice} />,
    },
    {
      label: "Settings",
      value: "2",
      hidden: !fullTaxInvoice.isEditable || fullTaxInvoice.isStoreAdmin,
      panel: <FullTaxInvoiceSettings {...fullTaxInvoice} />,
    },
  ];

  return (
    <ContentLayout
      title="Full Tax Invoices"
      breadcrumbs={<HeaderBreadcrumbs links={breadcrumbs} />}
      tabProps={{
        label: "fullTaxInvoice",
        list: tabs,
      }}
    />
  );
};
